export default "__VITE_ASSET__zkaeIjpt__"